import { Component, OnInit, OnDestroy } from '@angular/core';

import 'flowbite';
import { initFlowbite } from 'flowbite';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'ParkraumPlus V5';

  ngOnInit(): void {
    initFlowbite();
  }
}
